// removed by extract-text-webpack-plugin
module.exports = {"PaymentRequestButton":"payment-request-button__PaymentRequestButton__4foZg","tip-label":"payment-request-button__tip-label__3E9m7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rsvp_modal/payment-request-button.scss
// module id = 1282
// module chunks = 1